import { type DomainAccessControlConfig } from 'domains/storefront/utils/domain/accessControl'
import { Permission } from 'domains/storefront/access-control/permissions'
import { Flipper } from 'domains/storefront/access-control/flippers'

export const storefrontAccessControl: DomainAccessControlConfig = {
  warehouseFlippers: Flipper.storefront,
}

export const navigationViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.StorefrontNavigationView],
  warehouseFlippers: Flipper.storefront,
}

export const navigationModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify, Permission.StoreConfigsModify],
  warehouseFlippers: Flipper.storefront,
}

export const pageBuilderViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.PageBuilderView],
  warehouseFlippers: Flipper.storefront,
}

export const pageBuilderModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify, Permission.PageBuilderModify],
  warehouseFlippers: Flipper.storefront,
}

export const readOnlyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ReadOnly],
}

export const navigationCollectionsAccessControl: DomainAccessControlConfig = {
  warehouseFlippers: [Flipper.storefront, Flipper.navigationCollections],
  permissions: [Permission.StoreConfigsView],
}

export const storeConfigurationDraftViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.StoreConfigurationDraftView],
  warehouseFlippers: Flipper.storefront,
}

export const storeConfigurationDraftModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify, Permission.StoreConfigurationDraftModify],
  warehouseFlippers: Flipper.storefront,
}
